import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { useSession } from './lib/session';
import { AppShell } from './components/AppShell';
import { RequireAuth } from './components/RequireAuth';
import { SubscriptionGate } from './components/SubscriptionGate';
import { LoginPage } from './routes/LoginPage';
import { ForgotPasswordPage } from './routes/ForgotPasswordPage';
import { DashboardPage } from './routes/DashboardPage';
import { SubscribePage } from './routes/SubscribePage';
import { FamiliesPage } from './routes/FamiliesPage';
import { YouthProfilePage } from './routes/YouthProfilePage';
import { SchedulePage } from './routes/SchedulePage';
import { ShiftDetailsPage } from './routes/ShiftDetailsPage';
import { MessagesPage } from './routes/MessagesPage';
import { MessageThreadPage } from './routes/MessageThreadPage';
import { InvoicesPage } from './routes/InvoicesPage';
import { InvoiceDetailsPage } from './routes/InvoiceDetailsPage';
import { MileagePage } from './routes/MileagePage';
import { BroadcastPage } from './routes/BroadcastPage';
import { MorePage } from './routes/MorePage';
import { DocumentsPage } from './routes/DocumentsPage';
import { DiscoverPage } from './routes/DiscoverPage';
import { SettingsPage } from './routes/SettingsPage';

export function App() {
  const hydrated = useSession((s) => s.hydrated);
  if (!hydrated) {
    return (
      <div className="center-screen">
        <div className="spinner" />
      </div>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/subscribe" element={<SubscribePage />} />

        <Route
          element={
            <RequireAuth>
              <SubscriptionGate>
                <AppShell />
              </SubscriptionGate>
            </RequireAuth>
          }
        >
          <Route path="/" element={<DashboardPage />} />

          {/* Phase 1 */}
          <Route path="/families" element={<FamiliesPage />} />
          <Route path="/families/:connectionId" element={<YouthProfilePage />} />
          <Route path="/schedule" element={<SchedulePage />} />
          <Route path="/schedule/:eventId" element={<ShiftDetailsPage />} />
          <Route path="/messages" element={<MessagesPage />} />
          <Route path="/messages/:connectionId" element={<MessageThreadPage />} />

          {/* Phase 2 */}
          <Route path="/invoices" element={<InvoicesPage />} />
          <Route path="/invoices/:invoiceId" element={<InvoiceDetailsPage />} />
          <Route path="/mileage" element={<MileagePage />} />
          <Route path="/broadcast" element={<BroadcastPage />} />
          <Route path="/more" element={<MorePage />} />

          {/* Phase 3 */}
          <Route path="/documents" element={<DocumentsPage />} />
          <Route path="/discover" element={<DiscoverPage />} />
          <Route path="/settings" element={<SettingsPage />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
